import React from "react";

export default (props) => {
    const value = props.configuration.valueField;
    const text = props.configuration.textField;
    const disabled = props.disabled != undefined ? { disabled: true } : {};

    const selectElement = (
        <select
            className={`${props.className || ""}`}
            id={props.id}
            name={props.name || ""}
            aria-label={props.labelText || ""}
            value={props.value}
            onChange={props.onChange}
            {...disabled}
        >
            {props.configuration.options.map((option) => (
                <option key={option[value]} value={option[value]}>
                    {option[text]}
                </option>
            ))}
        </select>
    );

    return (
        <div className={props.classNameContainer || ""}>
            {props.labelText ? (
                <label htmlFor={props.id}>{props.labelText}</label>
            ) : null}
            <div className="">{selectElement}</div>
        </div>
    );
};
